export const FundboxContainerStyle = ({ theme }) => ({
  marginBottom: '20px',
  [theme.breakpoints.up('md')]: {
    marginBottom: '30px'
  }
});
